export enum GroupBookingsQuestionsMode {
  Update = "update",
  Delete = "delete"
}

export enum GroupBookingsQuestionsOption {
  GroupThis = "GroupThis",
  GroupAll = "GroupAll"
}
